'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCogDatabaseInset, iconCogDatabaseInsetTag } from '@ni/nimble-components/dist/esm/icons/cog-database-inset';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCogDatabaseInset };
export { iconCogDatabaseInsetTag };
export const NimbleIconCogDatabaseInset = wrap(IconCogDatabaseInset);